import React from 'react'
import styles from './styles.module.scss'

type GiftCardFormContainerProps = {
  label: string
}

function GiftCardFormContainer({
  label,
  children
}: React.PropsWithChildren<GiftCardFormContainerProps>) {
  return (
    <div className={styles.giftCard__fieldsets}>
      <div className={styles.giftCard__label}>{label}</div>
      {children}
    </div>
  )
}

export default GiftCardFormContainer
